import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-475b5818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backgrnd" }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "general"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Dashboard ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Validar Afiliado")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Listado de Evaluaciones")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "general"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Dashboard ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Listado de Evaluaciones")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  key: 2,
  class: "general"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Dashboard ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-alt" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Expediente")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = {
  key: 3,
  class: "general"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Dashboard ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-building" }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Centros")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "img",
                src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (this.$store.state.user.type == 'Supervisor en Sitio')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("a", {
            class: "navbar-option",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push('/openEvaluacions'))),
            href: "#"
          }, _hoisted_8),
          _createElementVNode("a", {
            class: "navbar-option",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push('/evaluacions'))),
            href: "#"
          }, _hoisted_11),
          _hoisted_12,
          _hoisted_13
        ], 512)), [
          [_vShow, !$data.cargando]
        ])
      : _createCommentVNode("", true),
    (this.$store.state.user.type == 'Médico Nutricionista')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("a", {
            class: "navbar-option",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.$router.push('/evaluacions'))),
            href: "#"
          }, _hoisted_18),
          _hoisted_19,
          _hoisted_20
        ], 512)), [
          [_vShow, !$data.cargando]
        ])
      : _createCommentVNode("", true),
    (this.$store.state.user.type == 'Subgerente de Promoción de la Salud y Prevención de la Enfermedad (P&P)')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("a", {
            class: "navbar-option",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (this.$router.push('/expediente'))),
            href: "#"
          }, _hoisted_25),
          _hoisted_26,
          _hoisted_27
        ], 512)), [
          [_vShow, !$data.cargando]
        ])
      : _createCommentVNode("", true),
    (this.$store.state.user.type == 'Gerente de Operaciones')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("a", {
            class: "navbar-option",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (this.$router.push('/centros'))),
            href: "#"
          }, _hoisted_32),
          _hoisted_33,
          _hoisted_34
        ], 512)), [
          [_vShow, !$data.cargando]
        ])
      : _createCommentVNode("", true)
  ]))
}